
import apiClient from "./api/api";

export const azureBlobService = {
  // Générer une URL SAS pour télécharger le fichier
  generateSasUrl: async (blobName, containerName, expiryMinutes = 30) => {
    try {
      const response = await apiClient.get(
        `api/BlobStorage/generate-sas-url/${blobName}/${containerName}`,
        { params: { expiryMinutes } }
      );
      return response.data.url;
    } catch (error) {
      console.error('Erreur lors de la génération de l\'URL SAS:', error);
      throw error;
    }
  },

  // Télécharger un fichier depuis Blob Storage
  downloadFileFromBlob: async (blobName, containerName, fileName) => {
    try {
      const sasUrl = await azureBlobService.generateSasUrl(blobName, containerName);
      
      // Créer un lien de téléchargement
      const link = document.createElement('a');
      link.href = sasUrl;
      link.download = fileName || blobName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return sasUrl;
    } catch (error) {
      console.error('Erreur lors du téléchargement:', error);
      throw error;
    }
  },

  // Sauvegarder une copie dans Blob Storage
  saveToBlobStorage: async (fileBlob, fileName, containerName) => {
    try {
      const formData = new FormData();
      formData.append('file', fileBlob, fileName);

      const response = await apiClient.post(
        `api/BlobStorage/upload/${containerName}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la sauvegarde dans Blob Storage:', error);
      throw error;
    }
  }
};